export type SearchHit = {
  tekst: string;
  lon: number;
  lat: number;
};

export async function searchDAWA(q: string, signal?: AbortSignal): Promise<SearchHit[]> {
  const trimmed = q.trim();
  if (trimmed.length < 2) return [];
  const url =
    'https://api.dataforsyningen.dk/adresser/autocomplete' +
    `?q=${encodeURIComponent(trimmed)}&per_side=8`;
  const res = await fetch(url, { signal });
  if (!res.ok) return [];
  const data = (await res.json()) as Array<{
    tekst?: string;
    adresse?: { x?: number; y?: number };
    x?: number;
    y?: number;
  }>;
  return data
    .map<SearchHit | null>((d) => {
      const lon = d.adresse?.x ?? d.x;
      const lat = d.adresse?.y ?? d.y;
      const tekst = d.tekst ?? '';
      if (!Number.isFinite(lon) || !Number.isFinite(lat) || !tekst) return null;
      return { tekst, lon: lon as number, lat: lat as number };
    })
    .filter((h): h is SearchHit => h !== null);
}
